import { all, takeEvery, put, call, delay } from "redux-saga/effects";
import actions from "./actions";
import { notification } from "antd";
import {
  getAuthTokenRequest,
  getAdminTokenRequest,
  getCompaniesRequest,
  getCompaniesDetailsRequest,
} from "../../services/mainService";
import { jwtDecode } from "jwt-decode";
import { t } from "i18next";

export function* getAuthTokenSaga() {
  const getDelayTime = (expirationTime) => {
    const currentTime = Math.floor(new Date().getTime() / 1000);
    const timeToExpiration = expirationTime - currentTime;
    const minutesInSeconds = 1 * 60;
    return (timeToExpiration - minutesInSeconds) * 1000;
  };

  try {
    while (true) {
      const response = yield call(getAuthTokenRequest);

      if (response[0] === 200) {
        const token = response[1];
        yield put({
          type: actions.GET_AUTH_TOKEN_SUCCESS,
          token,
        });

        const decodedToken = jwtDecode(token);
        const expirationTime = decodedToken.exp;

        const delayTime = getDelayTime(expirationTime);

        if (delayTime > 0) {
          yield delay(delayTime);
        } else {
          continue;
        }
      }
      if (response[0] === 500) {
        notification.error({
          message: t("problemOccurred"),
          placement: "top",
        });
      }
    }
  } catch (error) {}
}

export function* getAdminTokenSaga({ company, nick, password }) {
  try {
    const response = yield call(getAdminTokenRequest, company, nick, password);

    if (response[0] === 200) {
      const adminToken = response[1];
      const adminTokenDetails = jwtDecode(adminToken);

      if (adminTokenDetails.admin === "false") {
        alert("Нямате администраторски права.");
        return;
      }

      yield put({
        type: actions.GET_ADMIN_TOKEN_SUCCESS,
        adminToken,
        adminTokenDetails,
      });
    } else if (response[0] === 400) {
      alert(
        "Грешни данни за вход. Потребителското име, паролата или името на компанията, които въведохте, са некоректни"
      );
    } else if (response[0] === 500) {
      alert("Възникна проблем, моля опитайте по-късно");
    }
  } catch (error) {
    console.error("Error:", error);
  }
}

export function* getCompaniesSaga({ token }) {
  try {
    const response = yield call(getCompaniesRequest, token);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_COMPANIES_SUCCESS,
        companies: response[1],
      });
    }
    if (response[0] === 500) {
      notification.error({
        message: t("problemOccurred"),
        placement: "top",
      });
    }
  } catch (error) {}
}

export function* getCompaniesDetailsSaga({ token, id }) {
  try {
    const response = yield call(getCompaniesDetailsRequest, token, id);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_COMPANIES_DETAILS_SUCCESS,
        companiesDetails: response[1],
      });
    }
    if (response[0] === 500) {
      notification.error({
        message: t("problemOccurred"),
        placement: "top",
      });
    }
  } catch (error) {}
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_AUTH_TOKEN_REQUEST, getAuthTokenSaga),
    yield takeEvery(actions.GET_ADMIN_TOKEN_REQUEST, getAdminTokenSaga),
    yield takeEvery(actions.GET_COMPANIES_REQUEST, getCompaniesSaga),
    yield takeEvery(
      actions.GET_COMPANIES_DETAILS_REQUEST,
      getCompaniesDetailsSaga
    ),
  ]);
}
